import { z } from 'zod';
import { CUSTOMER_CONSTRAINTS as LIMITS } from './constraints.js';
/** New Customer's duplicate-name check: the name as typed so far. */
export const customerNameMatchArgsSchema = z.object({
    name: z.string().trim().min(1, `${LIMITS.name.label} is required.`).max(LIMITS.name.maxLength),
});
//# sourceMappingURL=name-match-args.js.map